import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "Avaliação clara",
  "Sem burocracia",
  "Atendimento humano",
  "Empresa independente",
  "Transparência",
  "Vitória da Conquista - BA",
];

export const EditorialMarquee = () => {
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-[#050505] border-y border-white/[0.05] py-8 overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-item text-2xl md:text-4xl font-medium tracking-tight px-8">
              {item}
            </span>
            <span className="text-white/15 text-2xl md:text-4xl">•</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
